import React from "react";
import useAuth from "../../useAuth";
import UnAuthorized from "./UnAuthorized";

export default function RequireAuth({ component, userTypes }) {
  const { user } = useAuth();

  if (!userTypes?.includes(user?.userType)) {
    return <UnAuthorized />;
  }

  return component;
}
